import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

import { RecipePanel, RecipeItem, RecipeDelimiter, RecipeAccordion, RecipeButton, RecipeMessage } from "./styles";

const EGiftRecipe = ({ deliveryDate, recipientName, giftCode, message, price, recipientEmail, totalPrice, payment: { card, purchased } }) => {
  const [isOpen, onClick] = useState(false);
  return (
    <RecipePanel>
      <RecipeItem>
        <span className="title">eGift Card</span>
        <span className="price small blue">${price}</span>
      </RecipeItem>
      <RecipeDelimiter />
      <RecipeItem>
        <span className="field">Recipient</span>
        <span className="value">{recipientName}</span>
      </RecipeItem>
      <RecipeItem>
        <span className="field">eGift Card ID</span>
        <span className="value">{giftCode}</span>
      </RecipeItem>
      <RecipeItem>
        <span className="field">Delivery Date</span>
        <span className="value">{moment(deliveryDate).format('MMM DD, YYYY')}</span>
      </RecipeItem>
      <RecipeDelimiter />
      <RecipeItem>
        <span className="field">Email</span>
        <span className="value">{recipientEmail}</span>
      </RecipeItem>
      <RecipeAccordion>
        <RecipeButton type="button" isOpen={isOpen} onClick={() => onClick(!isOpen)}>Message</RecipeButton>
        {isOpen && <RecipeMessage>{message}</RecipeMessage>}
      </RecipeAccordion>
      <RecipeItem>
        <span className="field bold">Total</span>
        <span className="price large bold">${totalPrice}</span>
      </RecipeItem>
      <RecipeDelimiter />
      <RecipeItem>
        <span className="field normal">{card.type}</span>
        <span className="value">•••• {card.num}</span>
      </RecipeItem>
      <RecipeItem>
        <span className="field normal">Purchased</span>
        <span className="value">{moment(purchased).format('MMM DD, YYYY')}</span>
      </RecipeItem>
    </RecipePanel>
  );
};

EGiftRecipe.propTypes = {
  deliveryDate: PropTypes.string,
  recipientName: PropTypes.string,
  giftCode: PropTypes.string,
  message: PropTypes.string,
  price: PropTypes.number,
  recipientEmail: PropTypes.string,
  totalPrice: PropTypes.number,
  payment: PropTypes.instanceOf(Object),
};

export default EGiftRecipe;
